import React from "react";
import { isMobile, isTablet } from "react-device-detect";
import { Alert } from "react-bootstrap";

const MobileBanner: React.FC = () => {
  const [show, setShow] = React.useState(true);

  if (!show || (!isMobile && !isTablet)) return null;

  return (
    <Alert variant="warning" onClose={() => setShow(false)} dismissible>
      This app works best on desktop. For the best experience, switch to a desktop browser.
    </Alert>
  );
};

export default MobileBanner;
